// Maximum request timeout in milliseconds (10 minutes)
// This value is set to accommodate potential delays with the PUT /application endpoint,
// which might take up to 10 minutes to complete as informed.
//minutes * seconds * ms
export const MAX_REQUEST_TIMEOUT = 10 * 60 * 1000;

export const MAX_KINEOX_WIDGET_TIMEOUT = 20 * 60 * 1000;

export const MAX_ONFIDO_WIDGET_TIMEOUT = 20 * 60 * 1000;

export const OFFER_PENDING_INTERVAL = 2 * 1000;

export const STATUS_CHECK_INTERVAL = 5 * 1000;

export const SUBMITING_INTERVAL = 5 * 1000;

export const widgetServices = Object.freeze({
  KINEOX: "Kineox",
  ONFIDO: "Onfido",
});

export const widgetStatuses = Object.freeze({
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  TIMEOUT: "TIMEOUT",
});
